import axios from "axios";

export const createTable = (body) => {
  return axios.post("/api/1.0/tables", body);
};

export const getTable = (tableId) => {
  return axios.get(`/api/1.0/tables/${tableId}`);
};

export const searchPageTables = (page, size, tableSearchDTO) => {
  const { idList, name, statusList, parentId } = tableSearchDTO;

  const params = new URLSearchParams();
  params.append("page", page);
  params.append("size", size);
  if (idList) {
    params.append("idList", idList);
  }
  if (name) {
    params.append("name", name);
  }
  if (statusList) {
    params.append("statusList", statusList);
  }
  if (parentId) {
    params.append("parentId", parentId);
  }

  return axios.get(`/api/1.0/tables/page?${params.toString()}`);
};

export const searchListTables = (tableSearchDTO) => {
  const { idList, name, statusList, parentId } = tableSearchDTO;

  const params = new URLSearchParams();
  if (idList) {
    params.append("idList", idList);
  }
  if (name) {
    params.append("name", name);
  }
  if (statusList) {
    params.append("statusList", statusList);
  }
  if (parentId) {
    params.append("parentId", parentId);
  }

  return axios.get(`/api/1.0/tables/list?${params.toString()}`);
};

export const updateTable = (tableId, body) => {
  return axios.put(`/api/1.0/tables/${tableId}`, body);
};

export const deleteTable = (tableId) => {
  return axios.delete(`/api/1.0/tables/${tableId}`);
};
